import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { EnglishTranslation, MalayTranslation } from '../app.constants';

@Component({
  selector: 'app-info-update-your-record',
  templateUrl: './info-update-your-record.component.html',
  styleUrls: ['./info-update-your-record.component.scss']
  })
export class InfoUpdateYourRecordComponent implements OnInit {
  Error: string;
  textContent: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private connect: ConnectRestService
  ) { }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.InforUpdateRecordScreen : MalayTranslation.InforUpdateRecordScreen; 
    // this.Error = localStorage.getItem("ErrorCode");
    // this.connect.clearSessionStorage()
  }  

  getQueryParams() {
    var params = { ...JSON.parse(localStorage.SavedQueryParams), productDescription: JSON.parse(localStorage.URLParam).ProductDescription };
    return params;
  }

}
